import { z } from 'zod'

import { AccountUserDisplayFlagType } from 'apps/dashboard/constants/DisplayFlagType'

export const FeedbackTikTokExperienceSchemas = {
  request: z.object({
    feedback: z.string(),
  }),
  query: z.undefined(),
  path: z.undefined(),
  response: z.undefined(),
}

export const FeedbackSegmentInsightsBlockSchemas = {
  request: z.object({
    feedback: z.string(),
  }),
  query: z.undefined(),
  path: z.undefined(),
  response: z.undefined(),
}

export const SetDisplayFlagSchemas = {
  path: z.undefined(),
  query: z.undefined(),
  request: z.object({
    display_flag: z.nativeEnum(AccountUserDisplayFlagType),
    value: z.boolean(),
  }),
  response: z.undefined(),
}
